/* global I18n */

import React from "react"
import FaIcon from "components/fa_icon"
import ExerciseExplanation from "./exercise_explanation"

function ExamQuestionSummary({
  exercise,
  set_question_modal_is_open
}) {
  const type = exercise?.exercise_type
  const spell_term_exercise = type === "spell_term"
  const qbe_exercise =
    type === "multi_choice_learnables" || type === "multi_choice_free_text"
  const status = exercise?.answer_status
  const user_answers = exercise?.user_answers
  const skipped = status === "skipped" || !status

  function correct_text_answer_box() {
    return (
      <div className="answer-item correct">
        <FaIcon name="fa-check" className="circle green" />
        <div>
          <div className="title">
            {I18n.t("js.new_embedded_quiz.exam_summary.correct_answer", {
              count: exercise.correct_answers.length
            })}
          </div>
          <div className={`${spell_term_exercise ? "no-bullets" : ""}`}>
            <ul>
              {exercise.correct_answers.map((answer, index) => (
                <li key={index}>{answer.title}</li>
              ))}
            </ul>
          </div>

          {spell_term_exercise && (
            <>
              {exercise.correct_answers.map((answer, index) => (
                answer.synonyms.length > 0 && (
                  <div className="synonyms" key={index}>
                    <div className="divider"></div>
                    <div className="title">
                      {I18n.t("js.new_embedded_quiz.exam_summary.synonyms")}
                    </div>
                    <ul>
                      {answer.synonyms.map((synonym, synonym_index) => (
                        <li key={synonym_index}>{synonym}</li>
                      ))}
                    </ul>
                  </div>
                )
              ))}
            </>
          )}
        </div>
      </div>
    )
  }

  function you_skipped_box() {
    return (
      <div className="answer-item skipped">
        <FaIcon name="fa-minus" className="circle gray"/>
        {I18n.t("js.new_embedded_quiz.exam_summary.you_skipped")}
      </div>
    )
  }

  function your_text_answer() {
    return (
      <div className="answer-item failed">
        <FaIcon name="fa-times" className="circle red"/>
        <div>
          <div className="title">
            {I18n.t("js.new_embedded_quiz.exam_summary.your_answer", {
              count: user_answers.length
            })}
          </div>
          <div className={`${spell_term_exercise ? "no-bullets" : ""}`}>
            <ul>
              {user_answers.map((answer, index) => (
                <li key={index}>{answer}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    )
  }

  function image_question() {
    return (
      <div className="image image-question">
        <img src={exercise?.image_url}
             alt=""
             width="100"
             height="100"
        />
      </div>
    )
  }

  return (
    <div>
      <div className="modal-header">
        <h3 className="modal-title">
          <div className="click-to-return"
               onClick={() => set_question_modal_is_open(false)}>
            <FaIcon name="fa-angle-left"/>
            {I18n.t("js.new_embedded_quiz.exam_summary.question_summary")}
          </div>
          <button className="btn btn-link close"
                  onClick={() => set_question_modal_is_open(false)}
          ></button>
        </h3>
      </div>
      <div className="modal-body">
        <div className="exercise-question">
          <div className="question">{exercise?.question}</div>
        </div>
        {spell_term_exercise &&
          <div className="explanation-container">
            {image_question()}
            <div className="answer">
              {status === "failed" && your_text_answer()}
              {skipped && you_skipped_box()}
              {correct_text_answer_box()}
            </div>
          </div>
        }
        {qbe_exercise &&
          <div className="qbe-container">
            {exercise?.image_url && image_question()}
            <div className="answer">
              {status === "failed" && your_text_answer()}
              {skipped && you_skipped_box()}
              {correct_text_answer_box()}
            </div>
            <ExerciseExplanation explanation={exercise.explanation}/>
          </div>
        }
      </div>
    </div>
  )
}

export default ExamQuestionSummary
